export default "__VITE_ASSET__CLIpL49q__"